import {
    GET_MY_ORDERS,
    SET_MY_ORDERS,
    GET_ROW_DATA,
    GET_ACTION_COLUMN,
    GET_MY_ORDERS_GRID_COUNT,
    SET_MY_ORDERS_GRID_COUNT
} from './types'

const getMyOrder = (emailId:any) => {
    return {
        type: GET_MY_ORDERS,
       emailId
    }
}
const setMyOrder = (value:any) => {
    return {
        type: SET_MY_ORDERS,
        value
    }
}

const getMyOrderGridCount = () => {
    return {
        type: GET_MY_ORDERS_GRID_COUNT,
    }
}
const setMyOrderGridCount = (gridCount:any) => {
    return {
        type: SET_MY_ORDERS_GRID_COUNT,
        gridCount
    }
}

const getRowData = (data:any) => {
    return {
      type: GET_ROW_DATA,
      payload: data
    }
  }
const getActionColumn = (data:any) => {
return {
    type: GET_ACTION_COLUMN,
    payload: data
}
}
export {
    getMyOrder,
    setMyOrder,
    getMyOrderGridCount,
    setMyOrderGridCount,
    getRowData,
    getActionColumn
}